module.exports = __webpack_public_path__ + "img/contact.4f155f6a.jpg";